module.exports = __webpack_public_path__ + "img/bule4.57aa26db.png";